module.exports = __webpack_public_path__ + "resources/img/img_moai_main_func_m.a2101f21f95459f6ca195ce78639de65.png";